import React from 'react';
import {Link} from 'react-router-dom';

import {ArticleCoverBlock} from './ArticleCoverBlock';
import styles from './styles.module.scss';

const getTypeLabel = (content) => {
    const type =
        content && (content.type || content.contentType) ? String(content.type || content.contentType).toLowerCase() : '';

    if (type === 'video') {
        return 'Видео';
    }

    return 'Статья';
};

const getCoverUrl = (content) => {
    const coverValue =
        content && (content.coverUrl || content.cover || content.previewImage || content.image || content.preview);

    if (coverValue && typeof coverValue === 'object') {
        return coverValue.url || coverValue.path || '';
    }

    return coverValue || '';
};

const getFormattedDate = (content) => {
    const dateValue = content && (content.createdAt || content.updatedAt || content.date);

    if (!dateValue) {
        return '';
    }

    const parsedDate = new Date(dateValue);

    if (Number.isNaN(parsedDate.getTime())) {
        return '';
    }

    return new Intl.DateTimeFormat('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(parsedDate);
};

export const ContentListItem = ({ content }) => {
    if (!content) {
        return null;
    }

    const formattedDate = getFormattedDate(content);
    const typeLabel = getTypeLabel(content);
    const newsId = content._id || content.id;

    const card = (
        <article className={styles.item}>
            <div className={styles.coverWrapper}>
                <ArticleCoverBlock
                    coverUrl={getCoverUrl(content)}
                    title={content.title || 'Новость'}
                    defaultText={typeLabel === 'Видео' ? '#TESTUВидео' : '#TESTUСтатья'}
                />
            </div>

            {formattedDate ? <p className={styles.date}>{formattedDate}</p> : null}

            <h3 className={styles.title}>{content.title || 'Без названия'}</h3>
        </article>
    );

    if (!newsId) {
        return card;
    }

    return (
        <Link
            className={styles.cardLink}
            to={{
                pathname: `/news/detail/${newsId}`,
                state: { content }
            }}>
            {card}
        </Link>
    );
};
